import { CRYSTALLIZE_IDS } from "../../crystallize-constants.js";
export const isSubscriptionShape = (type) => isSubscriptionShapeSeries(type) ||
    isSubscriptionShapeSubscription(type) ||
    isSubscriptionShapeBookClub(type) ||
    isSubscriptionShapeDigitalService(type);
export const isSubscriptionShapeSeries = (type) => type === CRYSTALLIZE_IDS.SHAPE.PRODUCT.SERIES_SUBSCRIPTION.ID;
export const isSubscriptionShapeSubscription = (type) => type === CRYSTALLIZE_IDS.SHAPE.PRODUCT.SUBSCRIPTION.ID;
export const isSubscriptionShapeBookClub = (type) => type === CRYSTALLIZE_IDS.SHAPE.PRODUCT.BOOK_CLUB.ID;
export const isSubscriptionShapeDigitalService = (type) => type === CRYSTALLIZE_IDS.SHAPE.PRODUCT.DIGITAL_SERVICE.ID;
